<script>
// @ is an alias to /src
import Layout from "@/layout/Main.vue";

export default {
	 components: {
		  Layout
	 },

     data() {
        return {
            terms:{},
            errors: {},

           style: null,
        };
    },    

	 created() {
          this.style = document.createElement('link')
          this.style.setAttribute('rel', 'stylesheet')
          this.style.setAttribute('href', '/design/terms-of-use.css')
          document.head.appendChild(this.style)
    },

    beforeDestroy() {
        document.head.removeChild(this.style);
    },

    mounted() {
            this.fetchTerms();
        },

     methods: {

        fetchTerms() {
            let url = "about/terms";         
            this.$axios
            .get(url)
            .then((res) => {
                var responseData = res.data.data;
                console.log(responseData);
                this.terms = responseData;  
                        
                })
                .catch((err) => console.log(err));
                
            },        
        }  


}
</script>
<template>
    <layout>
<!--terms of use-->
    <div class="container-sm mt-5">
        <!-- <div v-html="terms.description"></div> -->
        <h1 style="text-align: center;">Terms and Conditions</h1>

        <h4>Account creation</h4>
        <p>A User can create an account on the Platform and can determine their own 
            “user name” and “password” which are determined by the User herself/himself. 
            The "user name" is personal to the User and the same “user name” is not given 
            to two different Users. The “password” is only known by the user. The user can 
            change the password at any time. It is solely under the responsibility of the user 
            to select and protect the password. Sigofood is not liable for any problems, 
            which may arise from the use of password. Sigofood informs the user about 
            the promotions, which take place in the user’s area and from which the user 
            may benefit, by emails. Sigofood may share your username and password with 
            the third party companies for the purpose of providing our Service – for 
            example, the phone number may be shared with the Merchant which deals with 
            take-out goods and services, in order to provide a faster and correct delivery. 
            For the user to connect to the services, which require an Account of the 
            Platform, the user must enter the user name and password. This process is called 
            “login” to the Platform. <br>
            By using this Platform, you warrant that any personal information provided 
            by you is true, accurate, current and complete in all respects and that you will 
            notify us immediately of any changes to your personal information by updating 
            your User profile on the Platform or by contacting us, you agree not to 
            impersonate any other person or entity or to use a false name or a name that 
            you are not authorized to use. <br>
            You are not allowed to register multiple Accounts for use by the same person. 
            Violation of this clause may result in termination of your account. Users' 
            passwords should be kept confidential at all times and must not be shared or 
            disclosed to anyone. You are responsible for all activities and orders that occur 
            or are submitted through your Account. If you know or suspect that someone 
            has knowledge of your password, then you should contact us immediately.
            You may not use the Platform for any unlawful or unauthorized purpose, 
            including without limitation to:<br>
            Distributing any unlawful, libelous, abusive, threatening, harmful, obscene or 
            otherwise objectionable material. Transmitting material that constitutes a 
            criminal offense, results in civil liability or otherwise breaches any laws, 
            regulations or codes of practice.<br>
            Interfering with any other persons use or enjoyment of the Platform.<br>
            Damaging, disabling or impairing the operation of this Platform or attempting 
            to gain unauthorized access to this Platform or to networks connected to it, 
            through hacking, spoofing or other such similar means.<br>
            We expect a device to hold one User account only. We may allow service in 
            such cases but we will not allow the use of promotions.<br>
            If you wish to delete your Account, please contact us via the Platform chat 
            feature requesting the same.
            </p>

        <h4>Intellectual property rights</h4>
        <p>The content on the Application and Site, including source code, databases, 
            functionality, software, website designs, audio, video, text, photographs and 
            graphics (the "Sigofood Content"), as well as the trademarks, service marks 
            and logos contained therein (the "Trademarks") are owned by or licensed to 
            Sigofood, and are subject to copyright and other intellectual property rights 
            laws in force in the Kingdom of Bahrain, and other international treaties. You 
            may not copy, reproduce, republish, download, post, broadcast, transmit, make 
            available to the public, or otherwise use any Sigofood Content in any way 
            except for your own personal, non-commercial use.</p>
            
        <h4>Limitation of liability</h4>
            <p>To the extent permitted by applicable law, Sigofood provides the 
                Application and content on an "as-is" and "as available" basis and we make no 
                representation or warranty of any kind, express or implied, regarding the 
                content or availability of the Application, or that it will be timely or error-free or 
                that defects will be corrected, or that the site or server that makes it available 
                are free of viruses or other harmful components. Subject to the above, neither 
                Sigofood nor any of its directors, officers, agents, employees or contractor 
                shall have any liability for any direct, indirect, special or consequential losses or 
                damages (including without limitation, damages for loss of business or loss of 
                profits), arising in contract, tort or otherwise from the use or inability to use this 
                site. Nothing in these terms shall exclude or limits liability for death or personal 
                injury resulting from our negligence or that of our agents or employees.
                </p>    

        <h4>Disclaimer</h4>
            <p>Your use of the Service is at your sole risk. The Service is provided on an “AS 
                IS” and “AS AVAILABLE” basis. The Service is provided without warranties of any 
                kind, whether express or implied, including, but not limited to, implied 
                warranties of merchantability, fitness for a particular purpose, non-infringement 
                or course of performance.<br>
                Sigofood its subsidiaries, affiliates, and its licensors do not warrant that &nbsp; a) 
                the Service will function uninterrupted, secure or available at any particular time 
                or location; &nbsp; b) any errors or defects will be corrected; &nbsp; c) the Service is free of 
                viruses or other harmful components; or &nbsp; d) the results of using the Service will 
                meet your requirements.
                </p>
         
        <h4>Force Majeure</h4>
            <p>Data Processor (or Service Provider) means any person (other than an 
                employee of the Data Controller) who processes the data on behalf of the Data 
                Controller. <br>
                We may use the services of various Service Providers in order to process your 
                data more effectively.</p>

        <h4>Indemnity</h4>
            <p>You agree to indemnify and hold us, our parents, subsidiaries and affiliates, 
                agents, officers, directors, or other employees harmless from any claim, 
                demand, or damage (whether direct, indirect, or consequential), including 
                reasonable attorneys' fees, made by anyone in connection with your use of the 
                Application, your Contributions, any alleged infringement of intellectual 
                property or other right of any person or entity relating to the Application, your 
                violation of these terms and conditions, and any other acts or omissions relating 
                to the Application.</p>

        <h4>User</h4>
            <p>The User is the individual using our Service. The User corresponds to the Data 
                Subject, who is the subject of Personal Data.</p>

        <h4>Severability</h4>
            <p>If any provision of these terms and conditions is judged to be illegal or 
                unenforceable, the continuation in full force and effect of the remainder of the 
                provisions herein shall not be prejudiced.</p>
                    
        <h4>Entire Agreement</h4>
                <p >These terms and conditions and the documents referred to herein contain the 
                    whole agreement between the parties relating to its subject matter and 
                    supersede all prior agreements, arrangements and understandings between the 
                    parties relating to its subject matter.</p>

        <h4>Law and jurisdiction</h4>
            <p>These terms and conditions and any dispute or claim arising out of, or in 
                connection, with them, their subject matter or formation (including non contractual disputes or claims) shall be governed by, and construed in 
                accordance with the laws of the Kingdom of Bahrain. The courts of the Kingdom 
                of Bahrain shall have exclusive jurisdiction to settle any dispute or claim arising 
                out of, or in connection with, these terms and conditions, its subject matter or 
                formation (including non-contractual disputes or claims)
                </p>

         <br><br>  
    </div>

    </layout>
</template>